import { render, staticRenderFns } from "./ChartBase.vue?vue&type=template&id=2c1cfd52&"
import script from "./ChartBase.vue?vue&type=script&lang=js&"
export * from "./ChartBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports